export default {
  'environments.title': 'Manage Environments',
  'environments.type.development': 'Development',
  'environments.type.testing': 'Testing',
  'environments.type.production': 'Production',
};
